var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailureReason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10408 0.000552472C6.65023 0.0315754 7.10482 0.292017 7.37902 0.821408L11.8663 9.88009C12.3014 10.7958 11.6277 12.0279 10.5221 12.0457H1.48567C0.479433 12.0297 -0.346176 10.8871 0.146687 9.87008L4.71781 0.811651C4.80337 0.649031 4.8424 0.601996 4.91621 0.516683C5.21292 0.172679 5.53741 -0.0114564 6.10408 0.000552472ZM6.03028 1.00054C5.8584 1.00905 5.70103 1.10537 5.61522 1.25498C4.03606 4.25194 2.51368 7.27967 1.03659 10.3284C0.899993 10.6349 1.13442 11.0282 1.47742 11.0447C4.49464 11.0935 7.51312 11.0935 10.5303 11.0447C10.8618 11.0287 11.111 10.6484 10.9729 10.3317C9.5236 7.28342 8.0295 4.25569 6.47811 1.25823C6.38654 1.09536 6.25219 0.997538 6.03028 1.00054Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41474 7.73659C6.40931 7.96928 6.21912 8.15508 5.98637 8.15508C5.75345 8.15508 5.56319 7.96903 5.55798 7.73617L5.48675 4.5523C5.48046 4.27112 5.70667 4.03979 5.98792 4.03979C6.26935 4.03979 6.49564 4.27143 6.48907 4.55278L6.41474 7.73659ZM5.44727 9.41351C5.44727 9.26115 5.49655 9.13505 5.59538 9.03473C5.69445 8.93466 5.8293 8.88437 6.00017 8.88437C6.1713 8.88437 6.30615 8.93466 6.40497 9.03473C6.5038 9.13505 6.55333 9.26115 6.55333 9.41351C6.55333 9.56037 6.50505 9.68321 6.40897 9.78203C6.31265 9.88085 6.17655 9.93039 6.00017 9.93039C5.82379 9.93039 5.68769 9.88085 5.59137 9.78203C5.4953 9.68321 5.44727 9.56037 5.44727 9.41351Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureReason);
export default __webpack_public_path__ + "static/media/failure_reason.2add6c58fe5992827c80fb96aa5fd117.svg";
export { ForwardRef as ReactComponent };